<script setup lang="ts">
import ButtonProfile from '@/assets/icons/Buttons/ButtonProfile.vue';
import { usePlatform } from '@/composables/usePlatform';
import { useSafeArea } from '@/composables/useSafeArea';
import { type MessageSchema } from '@/i18n';
import { useLayoutStore } from '@/stores/layoutStore';
import Button from 'primevue/button';
import { computed, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });
const route = useRoute();
const { topSafeArea } = useSafeArea();
const { isNative } = usePlatform();

watchEffect(() => {
  if (route.meta.headerConfig) {
    useLayoutStore().pageMeta.headerConfig = { ...route.meta.headerConfig };
  }
});

const headerStyle = computed(() => {
  if (isNative.value) {
    return {
      paddingTop: topSafeArea,
      height: `calc(6rem + ${topSafeArea})`,
    };
  }
  return {};
});
</script>

<template>
  <div class="container relative flex h-24 items-center justify-between print:hidden" :style="headerStyle">
    <div v-if="useLayoutStore().pageMeta.headerConfig.showBack" class="z-10 flex grow items-center justify-start">
      <Button
        rounded
        link
        icon="pi pi-chevron-left"
        class="text-xl"
        :pt="{ root: { class: ' !w-8 !h-8' } }"
        :pt-options="{ mergeProps: true }"
        @click="$router.go(-1)"
      />
    </div>
    <h2 class="absolute left-0 right-0 w-full text-center">
      {{ t(`pageTitle.${useLayoutStore().pageMeta.headerConfig.headerLabel}`) }}
    </h2>
    <div v-if="useLayoutStore().pageMeta.headerConfig.showProfile" class="flex grow items-center justify-end">
      <Button
        id="onboarding-profile-button"
        rounded
        link
        :pt="{ root: { class: '!p-1.5 !w-10 !h-10' } }"
        :pt-options="{ mergeProps: true }"
        @click="$router.push({ name: 'profile' })"
      >
        <template #icon>
          <ButtonProfile />
        </template>
      </Button>
    </div>
  </div>
</template>

<style scoped></style>
